import { createElement, FC } from 'react'

import { CreateComponentsUnion } from 'design-system/types'
import { cn } from '../../utils/cn'

type CardProps = CreateComponentsUnion<
  'div' | 'section' | 'article' | 'li',
  {
    hover?: boolean
  }
>

export const Card: FC<CardProps> = ({
  children,
  className,
  hover = false,
  as = 'div',
  ref,
  ...props
}) => {
  const cardClassName = cn(
    'relative rounded-lg bg-white shadow transition-all duration-200',
    {
      'cursor-pointer hover:translate-y-px hover:shadow-none': hover
    },
    className
  )

  return createElement(
    as,
    { ...props, className: cardClassName, ref } as object,
    children
  )
}
